import { gql } from '@apollo/client';

export const APPLICATION_AIDETECTION_FRAGMENT = gql`
  fragment Application_aiDetection on Application {
    aiDetection {
      isAi
      score
      tag
    }
  }
`;

export const APPLICATION_SUMMARY_FRAGMENT = gql`
  fragment Application_summaries on Application {
    summaries {
      totalCount
      nodes {
        id
        threshold
        aiDetection {
          isAi
          score
          tag
        }
        summaryPart: summary {
          header
          icon
          bonuspoints
          average
          points
          maxPoints
          threshold
          details {
            label
            question
            icon
            answer
            points
            bonuspoints
            isCorrect
            qualified
            media {
              kind
              link
              durationSeconds
              thumbnailLink
            }
            options {
              label
              points
              isCorrect
              answered
              evaluation {
                name
                value
                bonus_points
              }
            }
            aiDetection {
              isAi
              score
              tag
            }
            reset
          }
        }
        keywordSummary {
          isEmpty
          text
        }
      }
    }
  }
`;
